export const ORIENTATION_IMAGE_TEXT = 'imageText';
export const ORIENTATION_TEXT_IMAGE = 'textImage';
